import {pluck} from 'ramda';

import {EmailData} from '@dms/api/customer';

import {Nullish} from 'shared/web';

/**
 * Turns the e-mail rows of a form into the request rows: trims each e-mail and leaves out the
 * rows without one. `formIndexes` keeps the form row of each sent e-mail, so an API error on
 * `emails.N.email` can be shown on the right input.
 */
export const getEmailsRequestBody = (emails: EmailData[] | Nullish) => {
  const rows = (emails ?? []).flatMap((row, formIndex) => {
    const email = (row.email ?? '').trim();

    return email === '' ? [] : [{email: {type: row.type, email}, formIndex}];
  });

  return {emails: pluck('email', rows), formIndexes: pluck('formIndex', rows)};
};
